import { gql, useMutation, useQuery } from '@apollo/client'
import { Pipeline } from '@ui/__generated__/graphql'

const GetOnboardablePipeline = gql(`
  query GetOnboardablePipeline {
    onboardablePipeline {
      id
      name
    }
  }
`)

const AssignSourceToPipeline = gql(`
  mutation AssignSourceToPipeline($input: AssignSourceToPipelineInput!) {
    assignSourceToPipeline(input: $input) {
      id
      name
    }
  }
`)

export const GetOnboardablePipelineQuery = () => {
  return useQuery<{ onboardablePipeline: Pipeline }>(GetOnboardablePipeline, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
  })
}

export const AssignSourceToPipelineQuery = () => {
  return useMutation(AssignSourceToPipeline)
}
